module.exports = __webpack_public_path__ + "media/meta-knight.c04ac3e7.wav";